import React from 'react';
function Sort() {
    return (React.createElement("g", null,
        React.createElement("path", { d: "M3 18h6v-2H3v2zM3 6v2h18V6H3zm0 7h12v-2H3v2z" }),
        React.createElement("path", { fill: "none", d: "M0 0h24v24H0z" })));
}
export default Sort;
